import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const usePostPreviewTabsStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
      maxWidth: "1130px",
    },

    dialogPaper: {
      width: "100%",
      maxWidth: "1130px",
      maxHeight: "90vh",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      backgroundColor: "#181615",
      borderRadius: 20,
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        maxWidth: "100%",
        maxHeight: "90vh",
      },
    },
    title: {
      width: "100%",
      height: "60px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#FE5A97",
      fontSize: "20px",
      fontWeight: 600,
    },
    dialogContentNoPadding: {
      padding: "1px",
      overflowY: "auto",
      overflowX: "hidden",
      flex: 1,
      display: "flex",
      justifyContent: "center",
      "&::-webkit-scrollbar": {
        width: "8px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#1a1a1a",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#363636",
        borderRadius: "4px",
      },
    },
    previewContainer: {
      width: "100%",
      maxWidth: "1130px",
      margin: "0 auto",
      padding: "16px 24px 24px",
      boxSizing: "border-box",
      [theme.breakpoints.down("sm")]: {
        padding: "12px 16px 20px",
      },
    },
    mediaColumn: {
      flex: 1.1,
      marginRight: "24px",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      [theme.breakpoints.down("sm")]: {
        marginRight: 0,
        marginBottom: "16px",
        width: "100%",
      },
    },
    previewMedia: {
      width: "100%",
      maxWidth: 456,
      maxHeight: "520px",
      borderRadius: 16,
      objectFit: "cover",
    },
    emptyMedia: {
      width: "100%",
      minHeight: "260px",
      borderRadius: 16,
      border: "1px dashed #363636",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    infoColumn: {
      flex: 0.9,
      display: "flex",
      flexDirection: "column",
      gap: 0,
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    userRow: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    userAvatar: {
      width: 60,
      height: 60,
    },
    userName: {
      color: "#FFFFFF",
      fontSize: "18px",
      fontWeight: 600,
    },
    userHandle: {
      color: "#FE5A97",
      fontSize: "14px",
      fontWeight: 500,
    },
    captionBox: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      marginTop: "20px",
    },
    captionText: {
      color: "#FFFFFF",
      fontSize: "20px",
      fontWeight: 400,
      lineHeight: 1.5,
      whiteSpace: "pre-wrap",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px",
      },
    },
    hashtagsBox: {
      display: "flex",
      flexWrap: "wrap",
      gap: "8px",
    },
    hashtagsText: {
      color: "#FFFFFF",
      fontSize: "20px",
      fontWeight: 700,
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px",
        fontWeight: 400,
      },
    },
    buttonsRow: {
      marginTop: "auto",
      display: "flex",
      gap: "12px",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
    backButton: {
      background: "transparent",
      border: "1px solid #FE5A97",
      color: "#FFFFFF",
      textTransform: "none",
      fontSize: "16px",
      fontWeight: 600,
      borderRadius: 6,
      padding: "10px 16px",
      "&:hover": {
        background: "rgba(254, 90, 151, 0.1)",
      },
    },
    postButton: {
      background: "#FE5A97",
      color: "#FFFFFF",
      textTransform: "none",
      fontSize: "16px",
      fontWeight: 600,
      borderRadius: 6,
      padding: "10px 16px",
      "&:hover": {
        background: "#FE5A97DD",
      },
      "&:disabled": {
        opacity: 0.7,
        color: "#FFFFFF !important",
      },
      "&.Mui-disabled": {
        color: "#FFFFFF !important",
      },
    },
  }),
);

export default usePostPreviewTabsStyles;
